import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="page">Проверяем доступ…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}
